import { type FC, memo, useCallback, ChangeEvent, useRef, useState } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import { translationsEN } from '../translations/textTranslations';
import { translations } from './SelectLanguage';

import { ResultWithCorrectValue } from '../types';
import './SaveResultsPopUp.css';
import { fromatNameForSave } from './utils';

interface SaveResultsPopUpProps {
    onQuitClick: ()=> void;
    results: ResultWithCorrectValue[];
}

export const SaveResultsPopUp: FC<SaveResultsPopUpProps> = memo(({ results, onQuitClick }) => {
    const [validationWarningVisible, setValidationWarningVisible] = useState(true);
    const name = useRef("");

    const handleUpdateName = (event: ChangeEvent<{ value: string }>) => {
        name.current = event?.currentTarget?.value;
        if (name.current.length >= 5) {
            setValidationWarningVisible(false);
        } else {
            setValidationWarningVisible(true);
        }
    }
    
    const handleContinueClick = useCallback(() => {
        if (name.current.length >= 5) {
            const doc = new jsPDF();
    
            const displayResults = results.map((result) => [
                result.product,
                translationsEN[result.color],
                translationsEN[result.correctAnswer],
            ]);
            autoTable(doc, {
                head: [["Products","Patients answers", "Correct answer"]],
                body: [...displayResults],
            }, )
            doc.save(`${fromatNameForSave(name.current)}.pdf`);
        }
    },[results]);
    
    const handleQuitClick = useCallback(() => {
        onQuitClick();
    },[onQuitClick]);

    return (
        <div className="saveResultPopUp">
            <div className="saveResultsText">{translations.enterPatientsName}</div>
            <input
                className="inputField" 
                placeholder={translations.inputPlaceholder}
                type="text"
                onChange={handleUpdateName}
            />
            {validationWarningVisible && <div className="validate">{translations.validationText}</div>}
            {!validationWarningVisible && <div style={{height: "calc(1rem + 1px)"}}></div>}
            <div className="saveResultsButtonContainer">
                <button 
                    className="quitGameButton"
                    onClick={handleQuitClick}
                >
                    {translations.navigationBack}
                </button>
                <button 
                    className={validationWarningVisible ? "saveButton disabled": "saveButton"}
                    style={{background: "#1ddb24"}}
                    onClick={handleContinueClick}
                >
                    {translations.save}
                </button>
            </div>
        </div>
    );
});
